import { render, staticRenderFns } from "./topicCategoryHeaderTemplate.vue?vue&type=template&id=f5d2e4fc&"
import script from "./topicCategoryHeaderTemplate.vue?vue&type=script&lang=js&"
export * from "./topicCategoryHeaderTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports